import { useContext } from 'react';

import { SignUpStateContext } from '../context/state/SignUpStateContext';

export const useSignUpState = () => useContext(SignUpStateContext);
